import { create, test, enforce } from 'vest';
import isEmail from 'validatorIsEmail';
import { validationMappings } from './validatorMappings';

enforce.extend({ isEmail });

function applyTests(validationSuite, data) {
    validationSuite.forEach((field) => {
        const value = data[field.PropertyName];
        const validator = validationMappings[field.Rule];

        test(field.PropertyName, field.ErrorMessage, () => {
            if (validator) {
                validator(value, field.Arguments, data);
            } else {
                console.warn(`Validator for rule ${field.Rule} is not implemented.`);
            }
        }, field.Key);
    });
}

/* Suites are named by convention with the following format:  
   {Model}Suite
   Where the Model is the name of the entity being validated,
   suffixed with 'Suite'. This is the object you should pass
   intp the applyTests function.
*/
const validationSuites = {
   
    ApplyForm: create((data = {}) => {
        /* Add additional, client-only validation tests here. E.g.: 

            test('ApplyForm.FirstName', 'FirstName cannot be John', () => {
                enforce(data['ApplyForm.FirstName']).notEquals('John');
            });
        */

        applyTests(ApplyFormSuite, data);
    }),

    SubscribeJobAlertCommand: create((data = {}) => {
        /* Add additional, client-only validation tests here. */
        applyTests(SubscribeJobAlertCommandSuite, data);
    })

};

export { validationSuites };